package com.karyadina.cloudsync.util

import kotlin.js.Date

/**
 * Web (JavaScript) implementation of TimeUtil
 */
actual object TimeUtil {
    actual fun currentTimeMillis(): Long = Date.now().toLong()
    
    actual fun generateUUID(): String {
        // Simple UUID v4 generation for browser using native JS
        @Suppress("UnsafeCastFromDynamic")
        val randomBytes = js("function() { return Math.random(); }")
        
        val template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
        return template.map { char ->
            when (char) {
                'x' -> {
                    val random = (randomBytes() as Double * 16).toInt()
                    random.toString(16)
                }
                'y' -> {
                    val random = (randomBytes() as Double * 16).toInt()
                    (random and 0x3 or 0x8).toString(16)
                }
                else -> char.toString()
            }
        }.joinToString("")
    }

    actual fun parseIso8601(isoString: String): Long {
        return try {
            Date.parse(isoString).toLong()
        } catch (e: Exception) {
            0L
        }
    }
}

